import React from 'react';

export const KeyValue = ({ label, children }) => (
    <div className="ONCRP-TOOLS-QP-kv-item">
        <span>{label}</span>
        <p>{children || 'N/A'}</p>
    </div>
);

export const TagList = ({ title, items, createLink, tagClass = '' }) => {
    if (!items || items.length === 0) return null;
    return (
        <div className="ONCRP-TOOLS-QP-subsection">
             <h4>{title}</h4>
            <div className="ONCRP-TOOLS-QP-tags-container">
                {items.map((item, index) => {
                    const content = createLink ? (
                        <a
                            href={createLink(item)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {item}
                        </a>
                    ) : item;
                    return <span key={index} className={`ONCRP-TOOLS-QP-tag ${tagClass}`}>{content}</span>;
                })}
            </div>
        </div>
    );
};

// Parser for the raw CIViC CSQ field
export const parseCivicCsq = (csqString) => {
    if (!csqString) return [];
    const evidenceItems = csqString.split(',');
    
    return evidenceItems.map(item => {
        const fields = item.split('|');
        const type = fields[8] || 'N/A';
        let parsedItem = {
            allele: fields[0],
            consequence: fields[1],
            gene: fields[2],
            transcript: fields[5],
            protein_change: fields[7],
            type: type,
            clinical_significance: 'N/A',
            disease: 'N/A',
            drugs: 'N/A',
            level: 'N/A',
            rating: 'N/A',
            source: 'N/A'
        };

        if (type === 'evidence') {
            parsedItem.clinical_significance = fields[14];
            parsedItem.direction = fields[15];
            parsedItem.disease = fields[16];
            parsedItem.drugs = fields[17];
            parsedItem.level = fields[20];
            parsedItem.rating = fields[21];
            parsedItem.source = fields[11];
        } else if (type === 'assertion') {
            parsedItem.clinical_significance = fields[13];
            parsedItem.direction = fields[14];
            parsedItem.disease = fields[15];
            parsedItem.drugs = fields[16];
            parsedItem.source = `Assertion ID: ${fields[9]}`;
        }
        return parsedItem;
    });
}; 
